import { render, staticRenderFns } from "./estatisticaConfirmadosMatriculados.vue?vue&type=template&id=247e35e9&"
import script from "./estatisticaConfirmadosMatriculados.vue?vue&type=script&lang=js&"
export * from "./estatisticaConfirmadosMatriculados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports